import Vue from "vue";
import moment, { ISO_8601, MomentInput } from "moment";
import "moment/locale/pt-br";
moment.locale("pt-br");

Vue.filter("dateFormat", (value, format = "DD/MM/Y") => {
  const parsedDate = moment(value, ISO_8601);
  if (!parsedDate.isValid()) return "";
  return parsedDate.format(format);
});
